import { useState, useEffect, RefObject, useRef } from 'react'

import { checkTouchEvents } from 'utils/checkTouchEvents'
import { Events } from 'constants/events'

const useIsHideControls = (
  fakeContainerRef: RefObject<HTMLDivElement>,
  showTime: number,
  firstShowTime?: number,
  initOpen?: boolean
) => {
  const [isHideControls, setHideControls] = useState(false)
  const firstRunRef = useRef(true)

  const isTouched = checkTouchEvents()
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const removeTimeout = () => {
    if (timeoutRef.current === null) return

    clearTimeout(timeoutRef.current)
    timeoutRef.current = null
  }

  const handleControlsOnOut = () => {
    const timeout = firstRunRef.current && initOpen ? firstShowTime : showTime
    firstRunRef.current = false
    timeoutRef.current = setTimeout(() => {
      setHideControls(true)
      removeTimeout()
    }, timeout)
  }
  const handleControlsOnOver = () => {
    removeTimeout()
    setHideControls(false)
    if (isTouched) {
      handleControlsOnOut()
    }
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      setHideControls(false)
    }
  }

  useEffect(() => {
    handleControlsOnOut()
    if (fakeContainerRef && fakeContainerRef.current) {
      if (!isTouched) {
        fakeContainerRef.current?.addEventListener(Events.MOUSEOVER, handleControlsOnOver)
        fakeContainerRef.current?.addEventListener(Events.MOUSEOUT, handleControlsOnOut)
      } else {
        fakeContainerRef.current?.addEventListener(Events.CLICK, handleControlsOnOver)
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      fakeContainerRef.current?.removeEventListener(Events.MOUSEOVER, handleControlsOnOver)
      fakeContainerRef.current?.removeEventListener(Events.MOUSEOUT, handleControlsOnOut)
      fakeContainerRef.current?.removeEventListener(Events.CLICK, handleControlsOnOver)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isHideControls
}

export default useIsHideControls
